<template>
  <div
    :class="{'asc-panel':true,'in':ctx=='in','out':ctx!='in','clickable':clickable}"
    :style="(width)?'width:'+width:''"
    @click="e=>$emit('click',e)"
  >
    <div class="action-buttons">
      <slot name="actions"></slot>
    </div>
    <div class="infos">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "s-action-pannel",

  props: {
    clickable: { type: Boolean, default: true },
    value: {
      default: null
    },
    width: {
      type: String,
      default: null
    },
    wrap: {
      type: String,
      default: null
    }
  },
  methods: {}
};
</script>

<style scoped>
.asc-panel {
  flex-grow: 1;
  display: flex;
  /* border: wheat 1px solid; */
  border-radius: 5px;
  width: 95%;
}
.asc-panel.in {
  background: #009688;
}
.asc-panel.out {
  background: #7e331d;
}
.clickable {
  cursor: pointer;
  box-shadow: 1px 1px 3px #06404ab3;
}
.clickable:hover {
  box-shadow: 0px 0px 0px #06404ab3;
}
.asc-panel,
.action-buttons {
  float: left;
}
.asc-panel .infos {
  display: flex;
  align-items: center;
  float: right;
  flex-grow: 1;
  padding-left: 3px;
}
</style>
